import SearchBar from 'components/Autosuggest/Autosuggest';
import { Loading } from 'components/loading/Loading';
import React, { useEffect, useState } from 'react';
import { fetchSuppliersForDropDown } from 'services';
import { showError } from 'utils';
import styles from './index.module.scss';

const SupplierAutosuggest = props => {
  const [loading, setLoading] = useState(false);
  const [defaultSuggestions, setDefaultSuggestions] = useState<Record<string, any>[]>([]);
  const {
    supplierName,
    setSupplierName,
    setSupplier,
    setSupplierId,
    withSchedule,
  } = props;

  const fetchDefaultSuggestions = async () => {
    setLoading(true);
    try {
      const suggestions = await fetchSuppliersForDropDown({
        withSchedule,
      });
      setDefaultSuggestions(suggestions.map(suggestion => ({
        id: suggestion.objectId,
        // eslint-disable-next-line @typescript-eslint/camelcase
        full_name: suggestion.name,
        displayName: suggestion.name,
        email: suggestion.email?.toLowerCase(),
        phone: suggestion.phone,
        address: suggestion.address,
        schedule: suggestion.schedule,
      })));
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDefaultSuggestions();
  }, []);

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    setSupplier(suggestion);
    setSupplierId(suggestion.id);
  };
  
  if (loading) return <Loading type={'mini'} />;
  
  return (
    <div className={styles['autosuggest-container']}>
      <SearchBar
        isUser={true}
        local={true}
        value={supplierName}
        // eslint-disable-next-line @typescript-eslint/camelcase
        setValue={value => setSupplierName(value)}
        defaultSuggestions={defaultSuggestions}
        searchAPI={() => { }}
        searchAPIParam={''}
        onSuggestionClicked={handleSuggestionClick}
      />
    </div>
  );
};

export default SupplierAutosuggest;